import React from "react";
import NoImage from "../../../../Assets/no-img/noimage.jpg";

export default function KitImagePreview({ url }) {
  return (
    <>
      {url ? (
        <div style={{ width: "250px", height: "250px" }}>
          <img
            alt="kit-icon"
            src={url}
            className="w-100 h-100 object-fit-contain"
          />
        </div>
      ) : (
        <div style={{ width: "250px", height: "250px" }}>
          <img
            alt="kit-icon"
            src={NoImage}
            className="w-100 h-100 object-fit-contain"
          />
        </div>
      )}
    </>
  );
}
